/**
 * Calculate percentage with configurable decimal precision
 * @param params - Object containing amount, total, and optional decimals (default: 0 for whole numbers)
 * @returns Percentage as a number with specified decimal places
 */
export const calculatePercentage = (params: {
  amount: number
  total: number
  decimals?: number
}): number => {
  const { amount, total, decimals = 0 } = params
  // Handle division by zero
  if (total === 0) return 0
  const percentage = (amount / total) * 100
  return Math.round(percentage * Math.pow(10, decimals)) / Math.pow(10, decimals)
}

export const calculateGrowthPercentage = (current: number, previous: number) =>
  calculatePercentage({ amount: current - previous, total: previous })

export const calculateMedian = (arr: number[]): number => {
  if (arr.length === 0) return 0
  const sorted = [...arr].sort((a, b) => a - b)
  const mid = Math.floor(sorted.length / 2)
  return sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid]
}
